import loadable from '@loadable/component';
import Loading from '../components/Loader';

const Doe = loadable(() => import(/* webpackChunkName: "doe" */ '../pages/Doe'), {
  fallback: Loading
});

export default Doe;
